module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Press":"Press"},"sv":{"Press":"Press"}}')
  delete Component.options._Ctor
}
